export const COLLAPSED_PROMPT_ROWS = 5

const FALLBACK_LINE_HEIGHT = 20

export const exceedsCollapsedRows = (
	el: HTMLTextAreaElement,
	rows = COLLAPSED_PROMPT_ROWS,
) => {
	const style = getComputedStyle(el)
	const lineHeight = parseFloat(style.lineHeight) || FALLBACK_LINE_HEIGHT
	const padding =
		(parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0)
	return el.scrollHeight > lineHeight * rows + padding + 1
}
